export default __webpack_public_path__ + "static/media/reservation-criteria_helper.ae1a71db.png";